import { H2 } from "melodies-source/Text";
import styled from "styled-components";

export const CardTitle = styled(H2)`
  text-align: center;
  line-height: 21px;
  margin-bottom: 20px;

  ${({ theme }) => theme.media.mobile} {
    font-size: 22px;
    line-height: 1.4;
    margin-bottom: 15px;
  }
`;
